import groupedImage from "../../assets/softwareconsultinggroup.webp";
import { motion } from "framer-motion";

const HeroSection = () => {
    return(
        <section className="w-full bg-[#FAFAFA] py-20 px-4 sm:px-6">
        <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* LEFT CONTENT */}
          <motion.div
            className="w-full lg:w-[60%]"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <p className="text-[#119D57] font-semibold text-sm mb-3 uppercase tracking-wider">
              Software Consulting
            </p>
            <h1 className="text-[#1C1C1C] text-[40px] md:text-[48px] leading-[52px] md:leading-[58px] font-extrabold mb-[24px]">
              Accelerate innovation and
              <br className="hidden lg:block" />
              strategy with experts
            </h1>
            <p className="text-[#4D4D4D] text-[16px] md:text-[18px] leading-[28px] md:leading-[30px] max-w-[600px]">
              We provide expert guidance to help businesses choose, design, and
              implement the right technology solutions. It ensures smarter
              decision-making, optimized systems, and accelerated digital
              transformation.
            </p>
          </motion.div>

          {/* RIGHT IMAGE */}
          <motion.div
            className="w-full lg:w-[40%] flex justify-center lg:justify-end"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
          >
            <img
              src={groupedImage}
              alt="Software Consulting Illustration"
              className="w-[280px] sm:w-[360px] md:w-[420px] lg:w-full max-w-[500px] h-auto object-contain"
            />
          </motion.div>
        </div>
      </section>
    );
};
export default HeroSection;